<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              المركز العلاجى
            </li>
          </ol>
        </nav>
        <h1 class="sub-title mb-3">المركز العلاجى</h1>

        <!-- <a class="btn btn-primary" href="/Default#Specialties">التخصصات</a> -->
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <h4 class="sub-title"> المركز العلاجى</h4>
        </div>
        <div class="col-md-8 col-sm-12">
          <a class="btn mx-4 px-4 bg-site-color" href="/Default#Specialties" style="margin-top: 25px;border: none;">التخصصات</a> -->
    <!-- <button class="btn px-4 bg-site-color" [routerLink]="['/Sas/ConsultantPlatform']" style="margin-top: 25px;border: none;">حجز موعد</button> -->
    <!-- </div>
      </div>
    </div> -->

    <div class="container">
      <div class="medical-center medicalCenter">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color">
          مركز حلول التواصل لعلاج اضطرابات التخاطب والسمع
        </h3> -->
        <div class="section-title">
          <h2>مركز سلاسة لعلاج اضطرابات التخاطب والسمع</h2>
        </div>

        <div class="row g-24">
          <!-- <div class="col-lg-4">
            <img
              src=".././../../assets/images/Doctor-Examining-Child.jpg"
              class="img-fluid img-thumbnail-edit"
            />

            <div class="workingHours mt-4 px-1">
              <h3>ساعات العمل :</h3>
              <ul class="" style="list-style: circle">
                <li class="font-size-17 mb-3">
                  في الأيام العادية : من الساعة 02:00 ظهرا حتى الساعة 09:00 مساء
                  من السبت الى الخميس.
                </li>
                <li class="font-size-17">
                  خلال شهر رمضان : من الساعة 09:00 مساء حتى الساعة 01:30 بعد
                  منتصف الليل من السبت الى الخميس.
                </li>
              </ul>
            </div>
          </div> -->

          <div class="col-lg-8">
            <div class="medicalCenterContent">
              <p>
                انبثق من الشركة (مركز سلاسة لعلاج اضطرابات التخاطب والسمع)،
                والذي بدأنا أعماله في مدينة الرياض، بالمملكة العربية السعودية.
                ويقوم على المركز مختصون في مجالي التخاطب والسمع. ونتطلع من تأسيس
                هذا المركز أن نقدم أفضل الخدمات التشخيصية والعلاجية لمن يعانون
                من اضطرابات اللغة، والكلام، وضعف السمع، والتي تقدر نسبتهم في
                المجتمع 10%-15%.
              </p>
              <p>
                كما وضعنا نصب أعيننا أن نقدم أفضل الإجراءات الطبية كي نسهم في
                تقليل حجم هذه الإضطرابات ومضاعفاتها الجسدية والنفسية، عبر تحسين
                قدراتهم سلوكيا، ومعرفيا، والتواصل الفعّال مع المجتمع من خلال
                التعلم والتدريب والاكتشاف والمشاركة، مع العناية بالجانب النفسي
                والمعرفي لزرع الأمل والتقبل والمسؤولية لديهم، وكل ذلك من أجل
                وصولهم إلى حياة أفضل.
              </p>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="side-content card-light-border">
              <h3>ساعات العمل</h3>

              <div class="item">
                <h4>في الأيام العادية</h4>
                <p>
                  من الساعة 02:00 ظهرا حتى الساعة 09:00 مساء من السبت الى
                  الخميس.
                </p>
              </div>
              <div class="item">
                <h4>خلال شهر رمضان</h4>
                <p>
                  من الساعة 09:00 مساء حتى الساعة 01:30 بعد منتصف الليل من السبت
                  الى الخميس.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Goals center-goals">
      <div class="container auto">
        <!-- <div class="icon-container flex justfy-center pb-4">
          <i
            class="fas fa-hiking fa-5x icon-rounded bg-white text-site-color"
          ></i>
        </div>
        <h3 class="text-center heading-title mb-4 text-white">
          أهدافنا في المركز العلاجي
        </h3> -->

        <div class="section-title">
          <h2>أهدافنا في المركز العلاجي</h2>
        </div>

        <div class="col-12">
          <ul>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              تقديم الخدمة التشخيصية والعلاجية ذات العلاقة باضطرابات السمع
              والتخاطب .
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              استخدام أفضل الممارسات والتقنيات في علاج اضطرابات السمع والتخاطب .
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              جعل المركز في مصاف المراكز الطبية المتقدمة، ومرجعاً علمياً مهماً
              في مجال استخدام الوسائل والتقنيات التشخيصية والعلاجية المختلفة
              المبنية على البراهين في تقديم أفضل الخدمات الصحية .
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              تيسير إجراءات تلقي الخدمات الطبية التشخيصية والعلاجية والمتابعة
              وتقليل فترات انتظار المرضى .
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              تكثيف جهود التوعية الصحية والمسح الطبي؛ للتحديد المبكر لاضطرابات
              التخاطب والسمع مع استمرارية المشاركة الفعالة في أنشطة الخدمة
              المجتمعية .
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              التطوير المستمر لجودة الخدمات وسلامة المرضى وأداء العاملين بالمركز
              .
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="Pros center-pros">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color borderAfter">
          مزايا المركز العلاجى
        </h3> -->
        <div class="section-title">
          <h2>مزايا المركز العلاجى</h2>
        </div>

        <div class="row">
          <!-- <div class="col-sm-12 col-lg-6">
            <img
              src=".././../../assets/images/ArabicKidTalking.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div> -->

          <div class="col-12">
            <ul>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                العلاج الفردي للمساعدة على تحقيق أهداف التواصل الخاصة بالمريض
                بسرعة وكفاءة مع نتائج ملحوظة.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                العلاج الجماعي للوصول الى الغاية المرجوة من التواصل الفعال مع
                أفراد يحملون نفس المشكلة.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                الغرف العلاجية المصممة خصيصًا لتلبية احتياجات كل من الأطفال
                والبالغين.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                مكتبة واسعة من أدوات التقييم والعلاج.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                الوصول إلى أحدث الأبحاث في مجال اضطرابات التخاطب والسمع.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="OurServices center-services">
      <div class="container">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color borderAfter">
          خدماتنا
        </h3>
        <h4 class="text-center mb-4 text-site-color">
          خدمات المركز العلاجي تشمل علاج الإضطرابات التالية
        </h4> -->

        <div class="section-title">
          <h2>خدماتنا</h2>
          <p>خدمات المركز العلاجي تشمل علاج الإضطرابات التالية</p>
        </div>
        <div class="services-list row g-24">
          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات اللغة.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات النطق.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات التأتأة والتلعثم.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>الحبسة الكلامية.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات الصوت.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>صعوبات التواصل العصبية مثل الأبراكسيا والديسارثريا.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>التواصل البديل والمعزز.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>الضعف السمعي.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات السمع العصبية.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات السمع التوصيلية.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>اضطرابات التوازن والدوخة.</h3>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12">
            <div class="service-item card-light-border">
              <div class="icon">
                <img
                  src="assets/images/icons/healthcare-icon.svg"
                  alt="healthcare icon"
                />
              </div>
              <h3>المعينات الطبية (السماعات الطبية).</h3>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-sm-12 col-lg-6">
            <img
              src=".././../../assets/images/ArabicKidTalking.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div>

          <div class="col-sm-12 col-lg-6">
            <ul class="w-list font-size-lg text-muted">
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                اللغة.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                النطق.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                التأتأة والتلعثم.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>الحبسة
                الكلامية.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                الصوت.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>صعوبات
                التواصل العصبية مثل الأبراكسيا والديسارثريا.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>التواصل
                البديل والمعزز.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>الضعف
                السمعي.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                السمع العصبية.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                السمع التوصيلية.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>اضطرابات
                التوازن والدوخة.
              </li>
              <li class="flex">
                <i class="fas fa-caret-left text-site-color fa-2x"></i>المعينات
                الطبية (السماعات الطبية).
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
